import graphql from "babel-plugin-relay/macro";

const SendTicketToSmsQuery = graphql`
  query SendTicketToSmsQuery($bookingId: String!) {
    sendTicketToSms(bookingId: $bookingId){
      message
      status
    }
  }
`;

export default SendTicketToSmsQuery;